var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorderFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2859 3.99984L15.6193 7.33317H30.3359V23.9998H3.66927V3.99984H12.2859ZM13.6693 0.666504H3.66927C1.83594 0.666504 0.352604 2.1665 0.352604 3.99984L0.335938 23.9998C0.335938 25.8332 1.83594 27.3332 3.66927 27.3332H30.3359C32.1693 27.3332 33.6693 25.8332 33.6693 23.9998V7.33317C33.6693 5.49984 32.1693 3.99984 30.3359 3.99984H17.0026L13.6693 0.666504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderFolderIcon);
export default __webpack_public_path__ + "static/media/borderFolderIcon.7e7056a5444c25e933ed0b5beb6a0164.svg";
export { ForwardRef as ReactComponent };